<template>
  <div class="xwzxmain">
    <h2 class="xwzxtitle">
      {{title}}
    </h2>
    <div v-if="type=='text'">
      <div v-for="(item,index) in wzlist" :key="index" class="xwzxcont">
        {{item.content}}
      </div>

    </div>
    <div v-if="type=='image'" class="xwzximg">
      <img style="width:95%" :src="data" alt="">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: String,
    type: String,
    title: String
  },
  name: 'Xwzx',
  data () {
    return {
      wzlist: []
    }
  },

  created () {
    // this.change()
  },
  methods: {
    change () {
      if (this.type === 'text') {
        this.wzlist = this.data.split('。')
      }
    }
  }
}
</script>

<style scoped>
.xwzxmain {
  width: 100%;
}
.xwzximg {
  display: flex;
  justify-content: center;
  align-items: center;
}
.xwzxtitle {
  text-align: center;
}
.xwzxcont {
  text-indent: 30px;
  font-size: 18px;
  line-height: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/newsDetail/index.vue